import { IPeriodNames, PERIOD_NAMES } from 'components/BusinessToolForm/constants/periods';

export const getYearsPeriod = (period: IPeriodNames) => {
  switch (period) {
    case PERIOD_NAMES.MONTH_VALUES:
    case PERIOD_NAMES.QUARTER_VALUES:
      return 'y1';
    case PERIOD_NAMES.HALF_VALUES:
      return 'y3';
    case PERIOD_NAMES.YEAR_VALUES:
      return 'y5';
    default:
      return 'y1';
  }
};
